
<template>
   <div id="dashboard" class="content content--borderless">
      <div class="content__header">
         <div class="content__main-header">
            <div class="content__title">
               <div class="content__title__name">Dashboard &nbsp;<span class="text-primary">SDS</span> </div>
               <div class="content__title__description">Rekapitulasi pengusulan Standar Data Statistik.</div>
            </div>
            <div class="ml-auto d-flex align-items-center">
               <b-dropdown id="dropdown-1" class="button button--outlined button--sm" toggle-class="d-flex align-items-center button--sm color-lighter">
                  <template #button-content>
                     <VueFeather type="clock" size="14" stroke-width="2" style="display:nlock"></VueFeather> &nbsp; Periode Usulan : {{submissionPeriod}}
                  </template>
                  <b-dropdown-item 
                     v-for="(period , index) in options.submissionPeriod" :key="index"
                     :active="submissionPeriod == period.id"
                     @click="submissionPeriod = period.id"
                  >
                     {{period.id}}
                  </b-dropdown-item>
               </b-dropdown>
            </div>
         </div>
         <div class="tab-control" style="margin-left:-5px;margin-right:-5px">
            <div :class="tab.index == index ? 'tab-control__item tab-control__item--active':'tab-control__item'" 
               v-for="(item,index) in tab.items" :key="index" @click="tab.index = index">
               <div class="tab-control__item__name">{{item.name}}</div>
            </div>
         </div>
      </div>
      <div class="content__body">
         <b-tabs v-model="tab.index" nav-class="d-none" content-class="p-0">
            <b-tab>
               <div class="table-search mb-2 form form--sm">
                  <b-input-group >
                     <b-input-group-prepend is-text class="bg-none">
                        <VueFeather type="search" size="16" stroke-width="3" stroke="#919191" ></VueFeather>
                     </b-input-group-prepend>
                     <b-form-input 
                        type="search"
                        debounce="500"
                        v-model="bps_division_summaries.filter" 
                        placeholder="Filter berdasarkan nama Diretorat di BPS . . ." 
                        class="border-left-0 min-w-400"></b-form-input>
                  </b-input-group>
                  <button type="button" class="button" variant="primary" size="sm" @click="download" >
                     <VueFeather type="download" size="14" class="button__icon"></VueFeather>Export
                     
                  </button>
               </div>
               <div class="table-wrapper">
                  <b-table
                     class="table--light"
                     show-empty
                     :items="bps_division_summaries.filtered_items"
                     :fields="bps_division_summaries.fields"
                  >
                    
                     <template #cell(no)="data">
                        {{data.index+1}}
                     </template>
                     <template #empty>
                        <div class="table__empty">
                           <div v-if="bps_division_summaries.isLoading">
                              <VueFeather type="loader" animation="spin" size="18"></VueFeather> &nbsp; Memuat data</div>
                           <div v-else>
                              <VueFeather type="alert-circle" size="18"></VueFeather> &nbsp;
                              Tidak ada data yang tersedia
                           </div>
                        </div>
                     </template> 
                  </b-table>
               </div>
            </b-tab>
            <b-tab>
               <div class="d-flex ">
                  <div class="table-search mb-2 form form--sm flex-grow-1">
                     <div class="w-100">
                        <b-input-group >
                           <b-input-group-prepend is-text class="bg-none">
                              <VueFeather type="search" size="16" stroke-width="3" stroke="#919191" ></VueFeather>
                           </b-input-group-prepend>
                           <b-form-input 
                              type="search"
                              debounce="500"
                              v-model="walidata_summaries.filter" 
                              placeholder="Filter berdasarkan nama Walidata . . ." 
                              class="border-left-0 min-w-400"></b-form-input>
                        </b-input-group>
                     </div>
                     <!-- <Treeselect 
                        clearable
                        placeholder="Provinsi"
                        valueFormat="object"
                        v-model="province"
                        :options="options.province"
                        :normalizer="provinceNormalizer"
                        @input="getKabupatenKotaByIdProvinsi"
                        />
                     <Treeselect 
                        clearable
                        placeholder="Kabupaten/Kota"
                        v-model="city"
                        :options="options.city"
                        :loadOptions="loadOptions"
                        :disabled="!province"
                     /> -->
                     <div>
                        <button type="button" class="button" variant="primary" size="sm" @click="download" >
                           <VueFeather type="download" size="14" class="button__icon"></VueFeather>Export
                        </button>
                     </div>
                  </div>
               </div>
               <div class="table-wrapper">
                  <b-table
                     class="table--light"
                     show-empty
                     :items="walidata_summaries.filtered_items"
                     :fields="walidata_summaries.fields"
                  >
                     
                     <template #cell(no)="data">
                        {{data.index+1}}
                     </template>
                     <template #empty>
                        <div class="table__empty">
                           <div v-if="walidata_summaries.isLoading">
                              <VueFeather type="loader" animation="spin" size="18"></VueFeather> &nbsp; Memuat data</div>
                           <div v-else>
                              <VueFeather type="alert-circle" size="18"></VueFeather> &nbsp;
                              Tidak ada data yang tersedia
                           </div>
                        </div>
                     </template> 
                  </b-table>
               </div>
            </b-tab>
            <b-tab>
               <div class="table-search mb-2 form form--sm" >
                  <b-input-group >
                     <b-input-group-prepend is-text class="bg-none">
                        <VueFeather type="search" size="16" stroke-width="3" stroke="#919191" ></VueFeather>
                     </b-input-group-prepend>
                     <b-form-input 
                        type="search"
                        debounce="500"
                        v-model="requester_summaries.filter" 
                        placeholder="Filter berdasarkan nama Pengusul  . . ." 
                        class="border-left-0 min-w-400"></b-form-input>
                  </b-input-group>
                  <button type="button" class="button" variant="primary" size="sm" @click="download" >
                     <VueFeather type="download" size="14" class="button__icon"></VueFeather>Export
                     
                  </button>
               </div>
               <div class="table-wrapper">
                  <b-table
                     class="table--light"
                     show-empty
                     :items="requester_summaries.filtered_items"
                     :fields="requester_summaries.fields"
                  >
                     
                     <template #cell(no)="data">
                        {{data.index+1}}
                     </template>
                     <template #empty>
                        <div class="table__empty">
                           <div v-if="requester_summaries.isLoading">
                              <VueFeather type="loader" animation="spin" size="18"></VueFeather> &nbsp; Memuat data</div>
                           <div v-else>
                              <VueFeather type="alert-circle" size="18"></VueFeather> &nbsp;
                              Tidak ada data yang tersedia
                           </div>
                        </div>
                     </template> 
                  </b-table>
               </div>
            </b-tab>
            <b-tab>
               <div class="table-search mb-2 form form--sm" >
                  <b-input-group >
                     <b-input-group-prepend is-text class="bg-none">
                        <VueFeather type="search" size="16" stroke-width="3" stroke="#919191" ></VueFeather>
                     </b-input-group-prepend>
                     <b-form-input 
                        type="search"
                        debounce="500"
                        v-model="approver_summaries.filter" 
                        placeholder="Filter berdasarkan nama Pemeriksa  . . ." 
                        class="border-left-0 min-w-400"></b-form-input>
                  </b-input-group>
                  <button type="button" class="button" variant="primary" size="sm" @click="download" >
                     <VueFeather type="download" size="14" class="button__icon"></VueFeather>Export
                     
                  </button>
               </div>
               <div class="table-wrapper">
                  <b-table
                     class="table--light"
                     show-empty
                     :items="approver_summaries.filtered_items"
                     :fields="approver_summaries.fields"
                  >
                     
                     <template #cell(no)="data">
                        {{data.index+1}}
                     </template>
                     <template #empty>
                        <div class="table__empty">
                           <div v-if="approver_summaries.isLoading">
                              <VueFeather type="loader" animation="spin" size="18"></VueFeather> &nbsp; Memuat data</div>
                           <div v-else>
                              <VueFeather type="alert-circle" size="18"></VueFeather> &nbsp;
                              Tidak ada data yang tersedia
                           </div>
                        </div>
                     </template> 
                  </b-table>
               </div>
            </b-tab>
         </b-tabs>
      </div>
   </div>
</template>
<script>
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import "@/assets/scss/main.scss";
import sdsService from "../../services/SdsService";
import SettingService from "../../services/SettingService";
import VueFeather from 'vue-feather';
// import Treeselect from '@riophae/vue-treeselect'
import XLSX from 'xlsx';
import moment from 'moment';
import wilayahService from "../../services/WilayahService";
import store from "../../store";
export default({
   components:{
      VueFeather,
      // Treeselect,
   },
   data() {
      return {
         user:null,
         province:null,
         city:null,
         submissionPeriod:null,
         tab:{
            index:0,
            items:[
               {
                  name:'Internal BPS',
                  count : 0,
               },
               {
                  name:'Walidata Pusat',
                  count : 0,
               },
               {
                  name:'Pengusul',
                  count : 0,
               },
               {
                  name:'Pemeriksa',
                  count : 0,
               },
            ]
         },
         bps_division_summaries:{
            isLoading:false,
            filter:null,
            filtered_items:[],
            items: [],
            fields: [
               {
                  key:'no',
                  class:'text-center pl-4 w-51'
               },
               {
                  key: 'division',
                  label: 'Unit Kerja (Eselon 2)',
                  class:'text-left'
               },
               {
                  key: 'concept',
                  label: 'Konsep dan Definisi',
                  class:'text-center'
               },
               {
                  key: 'variable',
                  label: 'Variabel',
                  class:'text-center'
               },
               {
                  key: 'indicator',
                  label: 'Indikator',
                  class:'text-center'
               },
               {
                  key: 'total',
                  class:'text-center'
               },
            ],
            page_size: 10,
            current_page:1,
            total_pages: null,
         },
         walidata_summaries:{
            isLoading:false,
            filter:null,
            filtered_items:[],
            items: [],
            fields: [
               {
                  key:'no',
                  class:'text-center pl-4 w-51'
               },
               {
                  key: 'walidata',
                  label: 'Walidata',
                  class:'text-left'
               },
               
               {
                  key: 'concept',
                  label: 'Konsep dan Definisi',
                  class:'text-center'
               },
               {
                  key: 'variable',
                  label: 'Variabel',
                  class:'text-center'
               },
               {
                  key: 'indicator',
                  label: 'Indikator',
                  class:'text-center'
               },
               {
                  key: 'total',
                  class:'text-center'
               },
            ],
            page_size: 10,
            current_page:1,
            total_pages: null,
         },
         requester_summaries:{
            isLoading:false,
            filter:null,
            filtered_items:[],
            items: [],
            fields: [
               {
                  key:'no',
                  class:'text-center pl-4 w-51'
               },
               {
                  key: 'name',
                  label: 'Nama Pengusul',
                  class:'text-left'
               },
               {
                  key: 'concept',
                  label: 'Konsep dan Definisi',
                  class:'text-center'
               },
               {
                  key: 'variable',
                  label: 'Variabel',
                  class:'text-center'
               },
               {
                  key: 'indicator',
                  label: 'Indikator',
                  class:'text-center'
               },
               {
                  key: 'total',
                  class:'text-center'
               },
            ],
            page_size: 10,
            current_page:1,
            total_pages: null,
         },
         approver_summaries:{
            isLoading:false,
            filter:null,
            filtered_items:[],
            items: [],
            fields: [
               {
                  key:'no',
                  class:'text-center pl-4 w-51'
               },
               {
                  key: 'name',
                  label: 'Nama Pemeriksa',
                  class:'text-left'
               },
               {
                  key: 'concept',
                  label: 'Konsep dan Definisi',
                  class:'text-center'
               },
               {
                  key: 'variable',
                  label: 'Variabel',
                  class:'text-center'
               },
               {
                  key: 'indicator',
                  label: 'Indikator',
                  class:'text-center'
               },
               {
                  key: 'total',
                  class:'text-center'
               },
            ],
            page_size: 10,
            current_page:1,
            total_pages: null,
         },
         options:{
            province:[],
            city:[],
            submission_period:[]
         }
         
      }
   },
   async mounted(){
      await this.getSubmissionPeriod();
      this.getProvinsi();
      this.getBpsDivsionSummaries();
      this.getWalidataSummaries();
      this.getRequesterSummaries();
      this.getApproverSummaries();
      this.getUserInfo(store.getters["auth/user"])
   },
   watch:{
      'bps_division_summaries.filter'(){
         this.doFilter();
      },
      'walidata_summaries.filter'(){
         this.doFilter();
      },
      'requester_summaries.filter'(){
         this.doFilter();
      },
      'approver_summaries.filter'(){
         this.doFilter();
      },
      province(){
         this.doFilter();
      },
      city(){
         this.doFilter();
      },
      submissionPeriod(){
         this.getBpsDivsionSummaries();
         this.getWalidataSummaries();
         this.getRequesterSummaries();
         this.getApproverSummaries();
      }
   },
   computed:{
      isAdmin(){
         return this.userRoles.includes("ROLE_SDS_ADMIN")
      },
      isPembinaDataPusat(){
         return this.userRoles.includes("ROLE_PEMBINA_DATA_PUSAT")
      },
      isPembinaDataProvinsi(){
         return this.userRoles.includes("ROLE_PEMBINA_DATA_PROVINSI")
      },
      isPembinaDataKabupatenKota(){
         return this.userRoles.includes("ROLE_PEMBINA_DATA_KABKOTA")
      },
      isWalidata(){
         return this.userRoles.includes("ROLE_WALIDATA_PUSAT") || this.userRoles.includes("ROLE_WALIDATA_PROVINSI") || this.userRoles.includes("ROLE_WALIDATA_KABUPATEN_KOTA");
      },
      isWalidataPusat(){
         return this.userRoles.includes("ROLE_WALIDATA_PUSAT");
      },
      isWalidataProvinsi(){
         return this.userRoles.includes("ROLE_WALIDATA_PROVINSI")
      },
      isWalidataKabupatenKota(){
         return this.userRoles.includes("ROLE_WALIDATA_KABKOTA")
      },
      isProdusenData(){
         return this.userRoles.includes("ROLE_PRODUSEN_DATA_PUSAT") || this.userRoles.includes("ROLE_PRODUSEN_DATA_PROVINSI") || this.userRoles.includes("ROLE_PRODUSEN_DATA_KABKOTA");
      },
      isProdusenDataKabupatenKota(){
         return this.userRoles.includes("ROLE_PRODUSEN_DATA_KABKOTA");
      },
      isBpsPusat(){
         return this.user && this.user.organization.name == 'Badan Pusat Statistik' ? true : false;
      },
      requesterSummariesFields(){
         return [
            {
               key:'no',
               class:'text-center pl-4 w-50'
            },
            {
               key: 'name',
               label: 'Nama Pengusul',
               class:'text-left'
            },
            {
               key: 'draft',
               label: 'Draft',
               class:'text-center'
            },
            {
               key: 'submitted',
               label: 'Submit',
               class:'text-center'
            },
            {
               key: 'revised',
               label: 'Perbaikan',
               class:'text-center'
            },
            {
               key: 'under_review',
               label: 'Diperiksa',
               class:'text-center'
            },
            {
               key: 'correction_required',
               label: 'Perbaikan',
               class:'text-center'
            },
            {
               key: 'rejected',
               label: 'Ditolak',
               class:'text-center'
            },
            {
               key: 'approved',
               label: 'Diterima',
               class:'text-center'
            },
            {
               key: 'pending',
               label: 'Ditunda',
               class:'text-center'
            },
            {
               key: 'published',
               label: 'Publish',
               class:'text-center'
            },
            {
               key: 'total',
               class:'text-center'
            },
         ];
      }
   },
   methods:{
      async getSubmissionPeriod(){
         await SettingService.getSdsSettings().then(
          (result)=>{
            let settingSubmissionPeriod = result.data.body.filter(x=>x.property == 'submission_period').map(x=>x.value);
            this.submissionPeriod = settingSubmissionPeriod[0];
            this.options.submissionPeriod = settingSubmissionPeriod.map(x=>{
               return {
                     id: parseInt(x), label:x
               }
            });
         },
         (error)=>{
            console.log(error)
         })
      },
      isTabShown(index){
         if(index == 0){
            return this.isBpsPusat ? true : false
         }
         else{
            return true;
         }
      },
      getUserInfo(user){
         this.user = {
         name : user.name,
         username: user.username,
         email: user.email,
         division: user.unitKerja,
         organization: {
            id: user.idOrganisasi,
            name: user.organisasi,
            address: null,
            province: {
               code: user.idProvinsi,
               name: user.provinsi,
            },
            city: {
               code: user.idKabupatenKota,
               name: user.kabupatenKota,
            },
         } 
         },
         this.myOrganizationId= user.idOrganisasi;
         this.userRoles = user.role.slice(1,-1).split(", ");
      },
      async getProvinsi(){
         await wilayahService.getProvinsi().then(
            (result) => {
               let options = result.data.data;
               this.options.province = options;
            },
            (error) => {
               this.error=error;
            }
         );
      },
      
      async getKabupatenKotaByIdProvinsi(){
         this.city = null;
         await wilayahService.getKabupatenKotaByIdProvinsi(this.province.id).then(
            (result) => {
               let options = result.data.data.map(x=>({id:x.kode, label:x.nama}));
               this.options.city = [{id:this.province.code+'00', label:'PROVINSI'}, ...options]
            },
            (error) => {
               this.error=error;
            }
         );
      },
      async getBpsDivsionSummaries(){
         this.bps_division_summaries.isLoading = true;
         await sdsService.getSdsItemSummaryByBpsDivision(this.submissionPeriod).then(
            (result) => {
               this.bps_division_summaries.items = result.data.result[0];
               this.bps_division_summaries.filtered_items = result.data.result[0];
               this.bps_division_summaries.isLoading = false;
            },
            (error) => {
                  console.log(error);
            }
         );
      },
      async getWalidataSummaries(){
         this.walidata_summaries.isLoading = true;
         await sdsService.getSdsItemSummaryByWalidata(this.submissionPeriod).then(
            (result) => {
               this.walidata_summaries.items = result.data.result[0];
               this.walidata_summaries.filtered_items = result.data.result[0];
               this.walidata_summaries.isLoading = false;
            },
            (error) => {
                  console.log(error);
            }
         );
      },
      async getRequesterSummaries(){
         this.requester_summaries.isLoading = false;
         await sdsService.getSdsItemSummaryByRequester(this.submissionPeriod).then(
            (result) => {
               this.requester_summaries.items = result.data.result[0];
               this.requester_summaries.filtered_items = result.data.result[0];
               this.requester_summaries.isLoading = false;
            },
            (error) => {
                  console.log(error);
            }
         );
      },
      async getApproverSummaries(){
         this.approver_summaries.isLoading = false;
         await sdsService.getSdsItemSummaryByApprover(this.submissionPeriod).then(
            (result) => {
               this.approver_summaries.items = result.data.result[0];
               this.approver_summaries.filtered_items = result.data.result[0];
               this.approver_summaries.isLoading = false;
            },
            (error) => {
                  console.log(error);
            }
         );
      },
      download(){
         /* make worksheet from json */
         const worksheetName = 'data';
         let data = null;
         let dashboard_type = null;
         if(this.tab.index == 0 ){
            dashboard_type = 'unit-kerja-bps'
            data = this.bps_division_summaries.filtered_items.map((item,index) =>{
               return {
                  'No' : index+1,
                  'Unit Kerja (Eselon 2)': item.division,
                  'Baru':item.new_submission,
                  'Pemutakhiran':item.update_submission,
                  'total':item.total
               }
            })
         }
         else if(this.tabs.index == 1 ){
            dashboard_type = 'organisasi-pengusul'
            data = this.walidata_summaries.filtered_items.map((item,index) =>{
               return {
                  'No' : index+1,
                  'Organisasi': item.organization,
                  'Baru':item.new_submission,
                  'Pemutakhiran':item.update_submission,
                  'total':item.total
               }
            })
         }
         else if(this.tab.index == 2 ){
            dashboard_type = 'pengusul'
            data = this.requester_summaries.filtered_items.map((item,index) =>{
               return {
                  'No' : index+1,
                  'Organisasi': item.organization,
                  'Baru':item.new_submission,
                  'Pemutakhiran':item.update_submission,
                  'total':item.total
               }
            })
         }
         //tabsIndex == 3
         else{
            dashboard_type = 'pemeriksa'
            data = this.approver_summaries.filtered_items.map((item,index) =>{
               return {
                  'No' : index+1,
                  'Organisasi': item.organization,
                  'Baru':item.new_submission,
                  'Pemutakhiran':item.update_submission,
                  'total':item.total
               }
            })
         } 
         const worksheetData = XLSX.utils.json_to_sheet(data)
         /* create a new blank workbook */
         const workbook = XLSX.utils.book_new()
         /* Add the worksheet to the workbook */
         XLSX.utils.book_append_sheet(workbook, worksheetData, worksheetName)
         /*create file*/
         const createdDate = moment(new Date()).format('DD_MM_YYYY');
         const fileName = 'dashboard-berdasarkan-'+dashboard_type+'_'+createdDate+'.xlsx'
         XLSX.writeFile(workbook,fileName)
      },
      doFilter(){
         let item = null;
         let filter = null;
         let province = this.province;
         let city = this.city;
         if(this.tab.index == 0 ){
            item = [...this.bps_division_summaries.items];
            filter = this.bps_division_summaries.filter;
            if(filter){
               this.bps_division_summaries.filtered_items = item.filter(x=> x.division.toLowerCase().includes(filter.toLowerCase()));
            }
            else{
               this.bps_division_summaries.filtered_items = item;
            }
         }
         else if(this.tab.index == 1 ){
            item = [...this.walidata_summaries.items];
            filter = this.walidata_summaries.filter;
            
            if(filter || province || city){
               if(filter){
                  this.walidata_summaries.filtered_items = item.filter(x=> x.organization.toLowerCase().includes(filter.toLowerCase()));
               }
               if(province){
                  this.walidata_summaries.filtered_items = item.filter(x=> x.province_code == province.code);
               }
               if(city){
                  this.walidata_summaries.filtered_items = item.filter(x=> x.city_code == city);
               }
            }
            else{
               this.walidata_summaries.filtered_items = item;
            }
         }
         else if(this.tab.index == 2 ){
            item = [...this.requester_summaries.items];
            filter = this.requester_summaries.filter;
            if(filter){
               this.requester_summaries.filtered_items = item.filter(x=> x.name.toLowerCase().includes(filter.toLowerCase()));
            }
            else{
               this.requester_summaries.filtered_items = item;
            }
         }
         //tabsIndex == 3
         else{
            item = [...this.approver_summaries.items];
            filter = this.approver_summaries.filter;
            if(filter){
               this.approver_summaries.filtered_items = item.filter(x=> x.name.toLowerCase().includes(filter.toLowerCase()));
            }
            else{
               this.approver_summaries.filtered_items = item;
            }
         } 
         
      },
      provinceNormalizer(node){
         return {
         id: node.id,
         label: node.name,
         }
      },
      loadOptions({callback}) {
         let result = 'Sedang melakukan load data'
         callback(null, result)
      },
   }
})
</script>
